import React from "react";
import { BlockMath } from "react-katex";

function getLatexString(dividend, divisor) {
  let latexExpressionTemplate = `\\frac{\\text{\\textit{${dividend}}} \\ast \\textit{100}}{\\text{\\textit{${divisor}}}}`;
  return latexExpressionTemplate;
}

const de = (
  <div>
    <p>Die Produktivität drückt das Verhältnis der auftragsbezogenen Stunden zur IST-Präsenzzeit aus.</p>
    <BlockMath>{getLatexString("Auftragsbezogene Stunden", "IST - Präsenzzeit")}</BlockMath>
  </div>
);

const fr = (
  <div>
    <p>La productivité exprime le rapport entre les heures liées aux mandats et le temps de présence effectif.</p>
    <BlockMath>{getLatexString("Heures liées aux mandats", "Temps de présence effectif")}</BlockMath>
  </div>
);

const it = (
  <div>
    <p>La produttività esprime il rapporto esistente tra le ore di lavoro riferite a mandati e il tempo di presenza effettivo.</p>
    <BlockMath>{getLatexString("Ore lavoro riferite a mandati", "Tempo di presenza effettivo")}</BlockMath>
  </div>
);

const en = (
  <div>
    <p>Productivity expresses the ratio of mandate-related hours to effective attendance time.</p>
    <BlockMath>{getLatexString("Mandate-related hours worked", "Effective attendance time")}</BlockMath>
  </div>
);

let text = {
  de,
  fr,
  it,
  en,
};

export default text;
